export default {
  title: 'Production Management',
  productionPlan: 'Production Plan',
};
